<div class="custom-security-link">
    <a [routerLink]="['/edit-profile', user?.cLPUserID]">User Profile</a>
    <a [routerLink]="['/user-prefs']" routerLinkActive="active">User Preferences</a>
    <a [routerLink]="['/user-defaults']" routerLinkActive="active">User Default</a>
    <a [routerLink]="['/longcodeline']" *ngIf="this.user?.slurpyUserId > 0" routerLinkActive="active">Virtual Phone Numbers</a>
    <a [routerLink]="['/cm-user-prefs']" *ngIf="companyData?.isClubModuleInstalled" routerLinkActive="active">Club User Preferences</a>
    <a [routerLink]="['/engage-prefs']" routerLinkActive="active">Engage Preferences</a>
    <a [routerLink]="['/engage-ignore-prefs']" routerLinkActive="active">Engage Email Ignore List</a>
</div>
<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <div class="global-header-section">
                <div class="svg-icon-panel"><img src="../../../../assets/clpusertitle.svg" class="mr-1" />Engage Dashboard Settings</div>
            </div>
            <div class="global-body-section">
                <form [formGroup]="userPreferenceForm" (ngSubmit)="saveUserPref()">
                    <div class="align-top-style">
                        <div class="wraper-body-panel">
                            <div class="wraper-body-left">
                                <lc-setting-form *ngIf="user" [user]="user" isFromLiveConnect="false"></lc-setting-form>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


